<ng-container *transloco="let t; read: 'toolsPage'">
  <crm-layout-admin-page>
    <mat-nav-list dense>
      <a mat-list-item [routerLink]="['/', 'persons', 'mail-sorter']" class="link" routerLinkActive="-active">
        <span matLine>{{ t('lettersDistribution') }}</span>
      </a>
      <a
        *ngIf="'ROLE_CRM2_CORRECT_STK' | hasPermission"
        mat-list-item
        [routerLink]="['/', 'admin', 'tools', 'stk-correction']"
        class="link"
        routerLinkActive="-active"
      >
        <span matLine>{{ t('correctionSTK') }}</span>
      </a>
      <a
        mat-list-item
        [routerLink]="['/', 'admin', 'tools', 'profiling-education-service']"
        class="link"
        routerLinkActive="-active"
      >
        <span matLine>{{ t('serviceReport') }}</span>
      </a>
      <a
        mat-list-item
        [routerLink]="['/', 'persons', 'messenger', 'unread-notifications']"
        class="link"
        routerLinkActive="-active"
      >
        <span matLine>{{ t('unreadMessagesWA') }}</span>
      </a>

      <a
        *ngIf="['ROLE_CRM2_BUSINESS_ANALYST', 'ROLE_CRM2_QA'] | hasPermission"
        mat-list-item
        [routerLink]="['/', 'admin', 'pil', 'templates']"
        class="link"
        routerLinkActive="-active"
      >
        <span matLine>{{ t('pilTemplatesEditor') }}</span>
      </a>
    </mat-nav-list>
  </crm-layout-admin-page>
</ng-container>
